import { render } from "./ConversationItem.vue?vue&type=template&id=1b26c88c&ts=true"
import script from "./ConversationItem.vue?vue&type=script&lang=ts"
export * from "./ConversationItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__